export default {
  pt: {
    'horasIndevidas.marcarEnviada': 'Marcar como enviada à ATS',
    'horasIndevidas.marcarEnviadaDica': 'Registra, com o seu usuário, a data e a hora, que as linhas selecionadas foram enviadas à ATS. As já confirmadas e as sem ajuste ficam como estão.',
    'horasIndevidas.marcarEnviada.mensagem_one': 'A ocorrência selecionada passa para Enviada à ATS, com o seu usuário, a data e a hora de agora.',
    'horasIndevidas.marcarEnviada.mensagem_other': 'As {{count}} ocorrências selecionadas passam para Enviada à ATS, com o seu usuário, a data e a hora de agora.',
    'horasIndevidas.marcarEnviada.ok_one': '{{count}} ocorrência marcada como Enviada à ATS.',
    'horasIndevidas.marcarEnviada.ok_other': '{{count}} ocorrências marcadas como Enviada à ATS.',
    'horasIndevidas.marcarEnviada.puladas': 'Ficaram como estavam: {{confirmadas}} já confirmadas e {{semAjuste}} sem ajuste.',
    'horasIndevidas.manual': 'Inclusão manual',
    'horasIndevidas.incluidoEm': 'Incluída em {{quando}} por {{quem}}',
    'horasIndevidas.dia.domingo': 'domingo',
    'horasIndevidas.dia.feriado': 'feriado',
    'horasIndevidas.erro.piso': 'No {{dia}}, a jornada ajustada não pode ficar abaixo de {{piso}}.',
    'horasIndevidas.erro.jornada': 'O ajuste não pode passar do Tempo de Jornada.',
    'horasIndevidas.incluir.titulo': 'Adicionar a Horas Indevidas',
    'horasIndevidas.incluir.horas': 'Horas',
    'horasIndevidas.incluir.minutos': 'Minutos',
    'horasIndevidas.incluir.batida': 'Batida a alterar',
    'horasIndevidas.incluir.batida.inicio': 'Início da jornada',
    'horasIndevidas.incluir.batida.fim': 'Fim da jornada',
    'horasIndevidas.incluir.salvar': 'Adicionar',
    'horasIndevidas.incluir.ok': 'Ocorrência adicionada a Horas Indevidas.',
    'horasIndevidas.incluir.dica': 'O tempo informado é descontado da batida escolhida. A ocorrência continua no Relatório de Ocorrências.',
    'horasIndevidas.incluir.limite': 'No {{dia}}, a jornada não fica abaixo de {{piso}}. O desconto máximo desta jornada é {{maximo}}, e um tempo maior fica limitado a ele.',
    'horasIndevidas.incluir.semPiso': 'No {{dia}}, a jornada de {{tempo}} não passa do mínimo de {{piso}}. Não há o que descontar.',
    'horasIndevidas.incluir.erro.zero': 'Informe um tempo a descontar maior que zero.',
    'horasIndevidas.incluir.erro.minutos': 'Os minutos vão de 00 a 59.',
    'horasIndevidas.incluir.erro.batida': 'Escolha a batida a alterar: início ou fim da jornada.',
    'horasIndevidas.incluir.erro.jornada': 'O desconto não pode passar do Tempo de Jornada, {{tempo}}.',
    'horasIndevidas.aba': 'Horas Indevidas',
    'horasIndevidas.contagem_one': '{{count}} ocorrência',
    'horasIndevidas.contagem_other': '{{count}} ocorrências',
    'horasIndevidas.hint': 'As ocorrências de TPI acima de 1 hora, TPF acima de 1 hora e as duas juntas tratadas como Gestão no Relatório de Infrações, mais as que foram adicionadas à mão pelo Relatório de Ocorrências, com o início e o fim da jornada sugeridos. No domingo a jornada não fica abaixo de 07h20, e no feriado, de 08h00. Confira, corrija se preciso, gere o Excel, marque as linhas enviadas à ATS e, quando a ATS devolver, confirme o ajuste.',
    'horasIndevidas.kpi.ocorrencias': 'Ocorrências',
    'horasIndevidas.kpi.ocorrenciasHint': 'exibidas conforme os filtros',
    'horasIndevidas.kpi.horasExtras': 'Horas extras identificadas',
    'horasIndevidas.kpi.horasExtrasHint': 'soma das horas extras de 50% e 100% das jornadas exibidas',
    'horasIndevidas.kpi.enviadas': 'Horas enviadas para ajuste',
    'horasIndevidas.kpi.enviadasHint': 'soma dos ajustes das linhas marcadas como Enviada à ATS',
    'horasIndevidas.kpi.economizadas': 'Horas economizadas',
    'horasIndevidas.kpi.economizadasHint': 'somente os ajustes confirmados como realizados pela ATS',
    'horasIndevidas.filtro.situacao': 'Situação',
    'horasIndevidas.situacao.sugerida': 'Sugerida',
    'horasIndevidas.situacao.editada': 'Editada',
    'horasIndevidas.situacao.enviada': 'Enviada à ATS',
    'horasIndevidas.situacao.confirmada': 'Confirmada',
    'horasIndevidas.col.data': 'Data',
    'horasIndevidas.col.dia': 'Dia',
    'horasIndevidas.col.colaborador': 'Colaborador',
    'horasIndevidas.col.ocorrencia': 'Ocorrência',
    'horasIndevidas.col.detalhe': 'Detalhe',
    'horasIndevidas.col.justificativa': 'Justificativa',
    'horasIndevidas.col.registro': 'Registrado por',
    'horasIndevidas.col.inicio': 'Início da jornada',
    'horasIndevidas.col.fim': 'Fim da jornada',
    'horasIndevidas.col.jornada': 'Tempo total da jornada',
    'horasIndevidas.col.horaExtra': 'Tempo total de hora extra',
    'horasIndevidas.col.situacao': 'Situação',
    'horasIndevidas.col.acoes': 'Ações',
    'horasIndevidas.antesEra': 'Antes era {{hora}}',
    'horasIndevidas.semMudanca': 'Sem alteração',
    'horasIndevidas.selecionar': 'Selecionar a ocorrência de {{dia}}',
    'horasIndevidas.selecionadas': '{{n}} de {{total}} selecionadas',
    'horasIndevidas.gerarExcel': 'Gerar Excel',
    'horasIndevidas.gerarExcelDica': 'Gera o arquivo para a ATS com as ocorrências selecionadas ou, sem seleção, com todas as exibidas. Gerar o arquivo não muda a situação das linhas.',
    'horasIndevidas.excelOk': 'Excel gerado. Depois de enviar o arquivo, marque as linhas como enviadas à ATS.',
    'horasIndevidas.editar': 'Editar horários',
    'horasIndevidas.editar.inicio': 'Início ajustado',
    'horasIndevidas.editar.fim': 'Fim ajustado',
    'horasIndevidas.editar.original': 'Horários originais',
    'horasIndevidas.editar.sugestao': 'Sugestão do HUB',
    'horasIndevidas.editar.voltarSugestao': 'Voltar à sugestão',
    'horasIndevidas.editar.previa': 'Depois do ajuste',
    'horasIndevidas.editar.ajusteInicio': 'Avanço do início',
    'horasIndevidas.editar.ajusteFim': 'Antecipação do fim',
    'horasIndevidas.editar.ajusteTotal': 'Ajuste total',
    'horasIndevidas.editar.salvar': 'Salvar horários',
    'horasIndevidas.editar.ok': 'Horários salvos.',
    'horasIndevidas.editar.limite': 'No {{dia}}, a jornada ajustada não fica abaixo de {{piso}}. O ajuste máximo desta jornada é {{maximo}}.',
    'horasIndevidas.erro.ordem': 'O início ajustado precisa ficar antes do fim ajustado.',
    'horasIndevidas.erro.inicioAntes': 'O início ajustado não pode ficar antes do início original da jornada.',
    'horasIndevidas.erro.fimDepois': 'O fim ajustado não pode ficar depois do fim original da jornada.',
    'horasIndevidas.confirmar': 'Confirmar ajuste na ATS',
    'horasIndevidas.confirmarDica': 'Marque a ocorrência como enviada à ATS antes de confirmar.',
    'horasIndevidas.desconfirmar': 'Desfazer a confirmação',
    'horasIndevidas.confirmadoOk': 'Ajuste confirmado. Ele passou a contar em Horas economizadas.',
    'horasIndevidas.desconfirmadoOk': 'Confirmação desfeita.',
    'horasIndevidas.enviadoEm': 'Enviado em {{quando}} por {{quem}}',
    'horasIndevidas.confirmadoEm': 'Confirmado em {{quando}} por {{quem}}',
    'horasIndevidas.editadoEm': 'Editado em {{quando}} por {{quem}}',
    'horasIndevidas.ocorrenciaInativa': 'A ocorrência já não existe no Relatório de Infrações. A linha segue pelo retrato guardado.',
    'horasIndevidas.vazio': 'Nenhuma ocorrência em Horas Indevidas com os filtros atuais.',
  },
  en: {
    'horasIndevidas.marcarEnviada': 'Mark as sent to ATS',
    'horasIndevidas.marcarEnviadaDica': 'Records, with your user, date and time, that the selected rows were sent to ATS. Rows already confirmed and rows without adjustment stay as they are.',
    'horasIndevidas.marcarEnviada.mensagem_one': 'The selected occurrence becomes Sent to ATS, with your user and the current date and time.',
    'horasIndevidas.marcarEnviada.mensagem_other': 'The {{count}} selected occurrences become Sent to ATS, with your user and the current date and time.',
    'horasIndevidas.marcarEnviada.ok_one': '{{count}} occurrence marked as Sent to ATS.',
    'horasIndevidas.marcarEnviada.ok_other': '{{count}} occurrences marked as Sent to ATS.',
    'horasIndevidas.marcarEnviada.puladas': 'Left as they were: {{confirmadas}} already confirmed and {{semAjuste}} without adjustment.',
    'horasIndevidas.manual': 'Added by hand',
    'horasIndevidas.incluidoEm': 'Added on {{quando}} by {{quem}}',
    'horasIndevidas.dia.domingo': 'Sunday',
    'horasIndevidas.dia.feriado': 'holiday',
    'horasIndevidas.erro.piso': 'On a {{dia}}, the adjusted shift cannot go below {{piso}}.',
    'horasIndevidas.erro.jornada': 'The adjustment cannot exceed the shift time.',
    'horasIndevidas.incluir.titulo': 'Add to Undue Hours',
    'horasIndevidas.incluir.horas': 'Hours',
    'horasIndevidas.incluir.minutos': 'Minutes',
    'horasIndevidas.incluir.batida': 'Punch to change',
    'horasIndevidas.incluir.batida.inicio': 'Shift start',
    'horasIndevidas.incluir.batida.fim': 'Shift end',
    'horasIndevidas.incluir.salvar': 'Add',
    'horasIndevidas.incluir.ok': 'Occurrence added to Undue Hours.',
    'horasIndevidas.incluir.dica': 'The time entered is deducted from the chosen punch. The occurrence stays in the Occurrences Report.',
    'horasIndevidas.incluir.limite': 'On a {{dia}}, the shift never goes below {{piso}}. The maximum deduction for this shift is {{maximo}}, and a longer time is capped at it.',
    'horasIndevidas.incluir.semPiso': 'On a {{dia}}, the {{tempo}} shift does not exceed the minimum of {{piso}}. There is nothing to deduct.',
    'horasIndevidas.incluir.erro.zero': 'Enter a time to deduct greater than zero.',
    'horasIndevidas.incluir.erro.minutos': 'Minutes go from 00 to 59.',
    'horasIndevidas.incluir.erro.batida': 'Choose the punch to change: shift start or shift end.',
    'horasIndevidas.incluir.erro.jornada': 'The deduction cannot exceed the shift time, {{tempo}}.',
    'horasIndevidas.aba': 'Undue Hours',
    'horasIndevidas.contagem_one': '{{count}} occurrence',
    'horasIndevidas.contagem_other': '{{count}} occurrences',
    'horasIndevidas.hint': 'Idle start over 1 hour, idle end over 1 hour and both together, treated as Management in the Violations Report, plus the ones added by hand from the Occurrences Report, with the suggested shift start and end. On Sundays the shift never goes below 07h20, and on holidays below 08h00. Review, correct if needed, generate the Excel, mark the rows sent to ATS and, once ATS confirms, mark the adjustment as done.',
    'horasIndevidas.kpi.ocorrencias': 'Occurrences',
    'horasIndevidas.kpi.ocorrenciasHint': 'shown with the current filters',
    'horasIndevidas.kpi.horasExtras': 'Overtime identified',
    'horasIndevidas.kpi.horasExtrasHint': 'sum of 50% and 100% overtime of the shifts shown',
    'horasIndevidas.kpi.enviadas': 'Hours sent for adjustment',
    'horasIndevidas.kpi.enviadasHint': 'sum of the adjustments of the rows marked as Sent to ATS',
    'horasIndevidas.kpi.economizadas': 'Hours saved',
    'horasIndevidas.kpi.economizadasHint': 'only the adjustments confirmed as applied by ATS',
    'horasIndevidas.filtro.situacao': 'Status',
    'horasIndevidas.situacao.sugerida': 'Suggested',
    'horasIndevidas.situacao.editada': 'Edited',
    'horasIndevidas.situacao.enviada': 'Sent to ATS',
    'horasIndevidas.situacao.confirmada': 'Confirmed',
    'horasIndevidas.col.data': 'Date',
    'horasIndevidas.col.dia': 'Day',
    'horasIndevidas.col.colaborador': 'Employee',
    'horasIndevidas.col.ocorrencia': 'Occurrence',
    'horasIndevidas.col.detalhe': 'Detail',
    'horasIndevidas.col.justificativa': 'Justification',
    'horasIndevidas.col.registro': 'Recorded by',
    'horasIndevidas.col.inicio': 'Shift start',
    'horasIndevidas.col.fim': 'Shift end',
    'horasIndevidas.col.jornada': 'Total shift time',
    'horasIndevidas.col.horaExtra': 'Total overtime',
    'horasIndevidas.col.situacao': 'Status',
    'horasIndevidas.col.acoes': 'Actions',
    'horasIndevidas.antesEra': 'Was {{hora}}',
    'horasIndevidas.semMudanca': 'Unchanged',
    'horasIndevidas.selecionar': 'Select the occurrence of {{dia}}',
    'horasIndevidas.selecionadas': '{{n}} of {{total}} selected',
    'horasIndevidas.gerarExcel': 'Generate Excel',
    'horasIndevidas.gerarExcelDica': 'Generates the ATS file with the selected occurrences or, with no selection, with all shown. Generating the file does not change the status of the rows.',
    'horasIndevidas.excelOk': 'Excel generated. After sending the file, mark the rows as sent to ATS.',
    'horasIndevidas.editar': 'Edit times',
    'horasIndevidas.editar.inicio': 'Adjusted start',
    'horasIndevidas.editar.fim': 'Adjusted end',
    'horasIndevidas.editar.original': 'Original times',
    'horasIndevidas.editar.sugestao': 'HUB suggestion',
    'horasIndevidas.editar.voltarSugestao': 'Back to suggestion',
    'horasIndevidas.editar.previa': 'After the adjustment',
    'horasIndevidas.editar.ajusteInicio': 'Start moved forward',
    'horasIndevidas.editar.ajusteFim': 'End moved back',
    'horasIndevidas.editar.ajusteTotal': 'Total adjustment',
    'horasIndevidas.editar.salvar': 'Save times',
    'horasIndevidas.editar.ok': 'Times saved.',
    'horasIndevidas.editar.limite': 'On a {{dia}}, the adjusted shift never goes below {{piso}}. The maximum adjustment for this shift is {{maximo}}.',
    'horasIndevidas.erro.ordem': 'The adjusted start must be before the adjusted end.',
    'horasIndevidas.erro.inicioAntes': 'The adjusted start cannot be before the original shift start.',
    'horasIndevidas.erro.fimDepois': 'The adjusted end cannot be after the original shift end.',
    'horasIndevidas.confirmar': 'Confirm adjustment in ATS',
    'horasIndevidas.confirmarDica': 'Mark the occurrence as sent to ATS before confirming.',
    'horasIndevidas.desconfirmar': 'Undo confirmation',
    'horasIndevidas.confirmadoOk': 'Adjustment confirmed. It now counts in Hours saved.',
    'horasIndevidas.desconfirmadoOk': 'Confirmation undone.',
    'horasIndevidas.enviadoEm': 'Sent on {{quando}} by {{quem}}',
    'horasIndevidas.confirmadoEm': 'Confirmed on {{quando}} by {{quem}}',
    'horasIndevidas.editadoEm': 'Edited on {{quando}} by {{quem}}',
    'horasIndevidas.ocorrenciaInativa': 'The occurrence no longer exists in the Violations Report. The row lives on by its saved snapshot.',
    'horasIndevidas.vazio': 'No occurrences in Undue Hours with the current filters.',
  },
  es: {
    'horasIndevidas.marcarEnviada': 'Marcar como enviada a la ATS',
    'horasIndevidas.marcarEnviadaDica': 'Registra, con su usuario, la fecha y la hora, que las filas seleccionadas fueron enviadas a la ATS. Las ya confirmadas y las sin ajuste quedan como están.',
    'horasIndevidas.marcarEnviada.mensagem_one': 'La ocurrencia seleccionada pasa a Enviada a la ATS, con su usuario, la fecha y la hora actuales.',
    'horasIndevidas.marcarEnviada.mensagem_other': 'Las {{count}} ocurrencias seleccionadas pasan a Enviada a la ATS, con su usuario, la fecha y la hora actuales.',
    'horasIndevidas.marcarEnviada.ok_one': '{{count}} ocurrencia marcada como Enviada a la ATS.',
    'horasIndevidas.marcarEnviada.ok_other': '{{count}} ocurrencias marcadas como Enviada a la ATS.',
    'horasIndevidas.marcarEnviada.puladas': 'Quedaron como estaban: {{confirmadas}} ya confirmadas y {{semAjuste}} sin ajuste.',
    'horasIndevidas.manual': 'Inclusión manual',
    'horasIndevidas.incluidoEm': 'Incluida el {{quando}} por {{quem}}',
    'horasIndevidas.dia.domingo': 'domingo',
    'horasIndevidas.dia.feriado': 'feriado',
    'horasIndevidas.erro.piso': 'En {{dia}}, la jornada ajustada no puede quedar por debajo de {{piso}}.',
    'horasIndevidas.erro.jornada': 'El ajuste no puede superar el tiempo de jornada.',
    'horasIndevidas.incluir.titulo': 'Agregar a Horas Indebidas',
    'horasIndevidas.incluir.horas': 'Horas',
    'horasIndevidas.incluir.minutos': 'Minutos',
    'horasIndevidas.incluir.batida': 'Marcación a cambiar',
    'horasIndevidas.incluir.batida.inicio': 'Inicio de la jornada',
    'horasIndevidas.incluir.batida.fim': 'Fin de la jornada',
    'horasIndevidas.incluir.salvar': 'Agregar',
    'horasIndevidas.incluir.ok': 'Ocurrencia agregada a Horas Indebidas.',
    'horasIndevidas.incluir.dica': 'El tiempo informado se descuenta de la marcación elegida. La ocurrencia sigue en el Informe de Ocurrencias.',
    'horasIndevidas.incluir.limite': 'En {{dia}}, la jornada no queda por debajo de {{piso}}. El descuento máximo de esta jornada es {{maximo}}, y un tiempo mayor queda limitado a él.',
    'horasIndevidas.incluir.semPiso': 'En {{dia}}, la jornada de {{tempo}} no supera el mínimo de {{piso}}. No hay qué descontar.',
    'horasIndevidas.incluir.erro.zero': 'Informe un tiempo a descontar mayor que cero.',
    'horasIndevidas.incluir.erro.minutos': 'Los minutos van de 00 a 59.',
    'horasIndevidas.incluir.erro.batida': 'Elija la marcación a cambiar: inicio o fin de la jornada.',
    'horasIndevidas.incluir.erro.jornada': 'El descuento no puede superar el tiempo de jornada, {{tempo}}.',
    'horasIndevidas.aba': 'Horas Indebidas',
    'horasIndevidas.contagem_one': '{{count}} ocurrencia',
    'horasIndevidas.contagem_other': '{{count}} ocurrencias',
    'horasIndevidas.hint': 'Las ocurrencias de TPI superior a 1 hora, TPF superior a 1 hora y las dos juntas tratadas como Gestión en el Informe de Infracciones, más las agregadas a mano desde el Informe de Ocurrencias, con el inicio y el fin de la jornada sugeridos. El domingo la jornada no queda por debajo de 07h20, y el feriado, de 08h00. Revise, corrija si hace falta, genere el Excel, marque las filas enviadas a la ATS y, cuando la ATS responda, confirme el ajuste.',
    'horasIndevidas.kpi.ocorrencias': 'Ocurrencias',
    'horasIndevidas.kpi.ocorrenciasHint': 'mostradas según los filtros',
    'horasIndevidas.kpi.horasExtras': 'Horas extras identificadas',
    'horasIndevidas.kpi.horasExtrasHint': 'suma de las horas extras de 50% y 100% de las jornadas mostradas',
    'horasIndevidas.kpi.enviadas': 'Horas enviadas para ajuste',
    'horasIndevidas.kpi.enviadasHint': 'suma de los ajustes de las filas marcadas como Enviada a la ATS',
    'horasIndevidas.kpi.economizadas': 'Horas ahorradas',
    'horasIndevidas.kpi.economizadasHint': 'solo los ajustes confirmados como realizados por la ATS',
    'horasIndevidas.filtro.situacao': 'Situación',
    'horasIndevidas.situacao.sugerida': 'Sugerida',
    'horasIndevidas.situacao.editada': 'Editada',
    'horasIndevidas.situacao.enviada': 'Enviada a la ATS',
    'horasIndevidas.situacao.confirmada': 'Confirmada',
    'horasIndevidas.col.data': 'Fecha',
    'horasIndevidas.col.dia': 'Día',
    'horasIndevidas.col.colaborador': 'Colaborador',
    'horasIndevidas.col.ocorrencia': 'Ocurrencia',
    'horasIndevidas.col.detalhe': 'Detalle',
    'horasIndevidas.col.justificativa': 'Justificación',
    'horasIndevidas.col.registro': 'Registrado por',
    'horasIndevidas.col.inicio': 'Inicio de la jornada',
    'horasIndevidas.col.fim': 'Fin de la jornada',
    'horasIndevidas.col.jornada': 'Tiempo total de la jornada',
    'horasIndevidas.col.horaExtra': 'Tiempo total de hora extra',
    'horasIndevidas.col.situacao': 'Situación',
    'horasIndevidas.col.acoes': 'Acciones',
    'horasIndevidas.antesEra': 'Antes era {{hora}}',
    'horasIndevidas.semMudanca': 'Sin cambio',
    'horasIndevidas.selecionar': 'Seleccionar la ocurrencia del {{dia}}',
    'horasIndevidas.selecionadas': '{{n}} de {{total}} seleccionadas',
    'horasIndevidas.gerarExcel': 'Generar Excel',
    'horasIndevidas.gerarExcelDica': 'Genera el archivo para la ATS con las ocurrencias seleccionadas o, sin selección, con todas las mostradas. Generar el archivo no cambia la situación de las filas.',
    'horasIndevidas.excelOk': 'Excel generado. Después de enviar el archivo, marque las filas como enviadas a la ATS.',
    'horasIndevidas.editar': 'Editar horarios',
    'horasIndevidas.editar.inicio': 'Inicio ajustado',
    'horasIndevidas.editar.fim': 'Fin ajustado',
    'horasIndevidas.editar.original': 'Horarios originales',
    'horasIndevidas.editar.sugestao': 'Sugerencia del HUB',
    'horasIndevidas.editar.voltarSugestao': 'Volver a la sugerencia',
    'horasIndevidas.editar.previa': 'Después del ajuste',
    'horasIndevidas.editar.ajusteInicio': 'Avance del inicio',
    'horasIndevidas.editar.ajusteFim': 'Anticipación del fin',
    'horasIndevidas.editar.ajusteTotal': 'Ajuste total',
    'horasIndevidas.editar.salvar': 'Guardar horarios',
    'horasIndevidas.editar.ok': 'Horarios guardados.',
    'horasIndevidas.editar.limite': 'En {{dia}}, la jornada ajustada no queda por debajo de {{piso}}. El ajuste máximo de esta jornada es {{maximo}}.',
    'horasIndevidas.erro.ordem': 'El inicio ajustado debe quedar antes del fin ajustado.',
    'horasIndevidas.erro.inicioAntes': 'El inicio ajustado no puede quedar antes del inicio original de la jornada.',
    'horasIndevidas.erro.fimDepois': 'El fin ajustado no puede quedar después del fin original de la jornada.',
    'horasIndevidas.confirmar': 'Confirmar ajuste en la ATS',
    'horasIndevidas.confirmarDica': 'Marque la ocurrencia como enviada a la ATS antes de confirmar.',
    'horasIndevidas.desconfirmar': 'Deshacer la confirmación',
    'horasIndevidas.confirmadoOk': 'Ajuste confirmado. Ya cuenta en Horas ahorradas.',
    'horasIndevidas.desconfirmadoOk': 'Confirmación deshecha.',
    'horasIndevidas.enviadoEm': 'Enviado el {{quando}} por {{quem}}',
    'horasIndevidas.confirmadoEm': 'Confirmado el {{quando}} por {{quem}}',
    'horasIndevidas.editadoEm': 'Editado el {{quando}} por {{quem}}',
    'horasIndevidas.ocorrenciaInativa': 'La ocurrencia ya no existe en el Informe de Infracciones. La fila sigue por el retrato guardado.',
    'horasIndevidas.vazio': 'Ninguna ocurrencia en Horas Indebidas con los filtros actuales.',
  },
}
